<template>
  <div>
    <div class="mx-5 py-5 px-2 d-flex justify-space-between">
      <h4>Edit Exam</h4>
    </div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="">
        <v-container class="">
          <v-select
            class="my-2"
            :items="ExamTypeList"
            v-model="exmaForm.ExamName"
            label="Exam Type"
            single-line
            :error-messages="
              $v.exmaForm.ExamName.$error
                ? 'Exam name is required'
                : null
            "
          ></v-select>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :nudge-top="20"
            :close-on-content-click="false"
            :return-value.sync="exmaForm.ExamDate"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="my-2"
                v-model="exmaForm.ExamDate"
                label="Exam Date"
                single-line
                append-icon="mdi-calendar-range-outline"
                v-bind="attrs"
                v-on="on"
                :error-messages="
              $v.exmaForm.ExamDate.$error
                ? 'Exam date is required'
                : null
            "
              ></v-text-field>
            </template>
            <v-date-picker v-model="exmaForm.ExamDate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu1.save(exmaForm.ExamDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-text-field
            class="my-2"
            v-model="exmaForm.WrittenScore"
            label="Written Score"
            type="number"
            single-line
            :error-messages="
              $v.exmaForm.WrittenScore.$error
                ? 'Written score is required'
                : null
            "
          ></v-text-field>
          <v-text-field
            class="my-2"
            v-model="exmaForm.PracticalScore"
            label="Practical Score"
            single-line
            type="number"
            :error-messages="
              $v.exmaForm.PracticalScore.$error
                ? 'Practical score is required'
                : null
            "
          ></v-text-field>
          <v-autocomplete
            class="my-2"
            v-model="exmaForm.InstructorId"
            :items="GetInstructors"
            item-text="FirstName"
            item-value="Id"
            label="Select Instructor"
            single-line
            :error-messages="
              $v.exmaForm.InstructorId.$error
                ? 'Instructor is required'
                : null
            "
          ></v-autocomplete>
          <v-autocomplete
            class="my-2"
            v-model="exmaForm.ExamCredential"
            :items="CredentialsArray"
            label="Exam Credentials"
            single-line
            item-text="name"
            item-value="id"
            :error-messages="
              $v.exmaForm.ExamCredential.$error
                ? 'Exam credential is required'
                : null
            "
          ></v-autocomplete>
        </v-container>
      </v-form>
      <div class="d-flex justify-end">
        <v-btn
          color="#C4C4C4"
          class="white--text py-5 px-8 mb-7"
          depressed
          @click="close()"
          ><span class="text_style">Cancel</span>
        </v-btn>
        <v-btn
          color="primary"
          class="white--text py-5 px-8 ml-4"
          depressed
          :disabled="btnloader"
          @click="save()"
          ><span v-if="btnloader != true"> Save </span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";

// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
export default {
  mixins: [validationMixin],
  name: "editusercomponent",
  props: ["editExamData"],
  data() {
    return {
      exmaForm: {
        ExamName: "",
        ExamDate: "",
        ExamCredential: "",
        WrittenScore: null,
        PracticalScore: null,
        InstructorId: null,
        Id: null,
      },
      btnloader: false,
      examdate: "",
      enddate: "",
      menu1: false,
      menu2: false,
      e2: "CBP",
      e3: null,
      e4: null,
      ExamTypeList: [
        "CBP",
        "CBP-A",
        "AdvCBP 4(7) & 9",
        "AdvCBP 3 & 6",
        "PaRama",
      ],
      CredentialsArray: [
        {name:"CBP",id:1}, {name:"CBP-A",id:2}, {name:"AdvCBP",id:3}, {name:"PaRama CBP",id:4}
      ],
      states: ["  CBP", "AdvCBP 4(7) & 9", "AdvCBP 3 & 6", "CBP-A", "PaRama"],
      items: ["[Blank]/None", "CBP", "CBP-A", "AdvCBP", "PaRama CBP"],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      Address: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  validations:{
  exmaForm: {
        ExamName: {
          required
        },
        ExamDate: {
          required
        },
        ExamCredential: {
          required
        },
        WrittenScore: {
          required
        },
        PracticalScore: {
          required
        },
        InstructorId: {
          required
        },
      }
},
  computed: {
    ...mapGetters(["GetInstructors", "GetPreviewUser"]),
  },
  mounted() {
    this.$store.dispatch("GetInstructors");
    if(this.editExamData){
      console.log(this.editExamData)
      this.exmaForm.ExamName = this.editExamData.ExamName
      this.exmaForm.ExamDate = this.editExamData?.ExamDate?.split("T")[0]
      this.exmaForm.ExamCredential = this.editExamData.Credential
      this.exmaForm.WrittenScore = this.editExamData.WrittenScore
      this.exmaForm.PracticalScore = this.editExamData.PracticalScore
      this.exmaForm.InstructorId = this.editExamData.InstructorId
      this.exmaForm.Id = this.editExamData.Id
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$v.exmaForm.$touch()
      if(this.$v.exmaForm.$invalid){
        return
      }
      this.btnloader = true;
      this.$store.dispatch("UpdateUserExams",this.exmaForm).then(()=>{
        this.btnloader = false;
        this.$swal({
          position: "top-end",
          icon: "success",
          title: "Edit successfully",
          showConfirmButton: false,
          timer: 1500,
          toast: true,
        });
        this.close();
      }).catch(()=>{
        this.btnloader = false;
        this.$swal({
          position: "top-end",
          icon: "success",
          title: "Not Edit Exam",
          showConfirmButton: false,
          timer: 1500,
          toast: true,
        });
        this.close();
      })
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
  padding: 0;
  background: transparent;
  border-style: dashed;
}
</style>
